<template>
  <fieldset>
    <div class="form-wrap">
      <div>
        <label for="name">Name</label>
        <input id="name" type="text" v-model="$parent.setting.name" />
      </div>

      <div>
        <label for="value">Value</label>
        <input id="value" type="text" v-model="$parent.setting.value" />
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "SystemSettingFields",
  data() {
    return {};
  }
};
</script>
